export const GET_CLAIM_HOME_DATA_PENDING = 'getClaimHomeDataPending';
export const GET_CLAIM_HOME_DATA_FULFILLED = 'getClaimHomeDataFulfilled';
export const GET_CLAIM_HOME_DATA_REJECTED = 'getClaimHomeDataRejected';